var util = {
    casLoginUrl : "https://login.cibr.ac.cn/?service=",
    casOutUrl : "https://login.cibr.ac.cn/logout",
    webCenter : "https://app.cibr.ac.cn/"
}
export default util;